import request from '../request';

export const getDestinations = () =>
  request.get('destinations').then((res) => res);
